// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyCreate_container__2v4LH","form":"CompanyCreate_form__3cmaJ"};